import { useMemo } from 'react';

import {
  IReservationObjectData,
  TUnits,
} from 'modules/accommodations/features/reservations/models';

export const useReduceObjects = (tableDataHelper: IReservationObjectData[]) => {
  return useMemo(() => {
    if (tableDataHelper.length < 1) return [];

    let reducedObjects: IReservationObjectData[] = [];

    if (tableDataHelper.length > 0) {
      reducedObjects = tableDataHelper?.reduce(
        (accumulator: IReservationObjectData[], currentValue: IReservationObjectData) => {
          if (currentValue?.units) {
            const objectUnitsChecked = currentValue.units.filter(
              (unit: TUnits) => unit.checked === true,
            );
            if (objectUnitsChecked.length > 0) {
              accumulator.push({ ...currentValue, units: objectUnitsChecked });
            }
          }

          return accumulator;
        },
        [],
      );
    }

    return reducedObjects;
  }, [tableDataHelper]);
};
